module.exports = __webpack_public_path__ + "static/media/save-icon.f9b53873.svg";